import * as fromDatatype from '../datatype-library/index';

// linking to other database table.

export interface app_login_subject_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  name_first: fromDatatype.VarcharDatatypeClass;
  name_last: fromDatatype.VarcharDatatypeClass;
  description: fromDatatype.TextDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  main_email: fromDatatype.VarcharDatatypeClass;
  main_phone: fromDatatype.VarcharDatatypeClass;
  login_subject_type: fromDatatype.VarcharDatatypeClass;
  mfa_enforced: boolean;
  mfa_status: fromDatatype.VarcharDatatypeInterface;
  app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
  validation_type: fromDatatype.VarcharDatatypeInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
  sidebar_enabled: boolean;
  menu_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class app_login_subject_RowClass
  implements app_login_subject_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  name_first: fromDatatype.VarcharDatatypeClass;
  name_last: fromDatatype.VarcharDatatypeClass;
  description: fromDatatype.TextDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  main_email: fromDatatype.VarcharDatatypeClass;
  main_phone: fromDatatype.VarcharDatatypeClass;
  login_subject_type: fromDatatype.VarcharDatatypeClass;
  mfa_enforced: boolean;
  mfa_status: fromDatatype.VarcharDatatypeInterface;
  app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
  validation_type: fromDatatype.VarcharDatatypeInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
  sidebar_enabled: boolean;
  menu_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
